import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { InputBase, InputAdornment } from '@material-ui/core'
import { useRouter } from 'next/router'
import URI from 'urijs'
import { BUTTON_NAME, EVENT_ACTION, COUPON_SCREEN_NAME } from 'tracking'

import { hidden, boxShadow, inputSearchCancelButtonStyle } from './mixin'
import { SearchIcon } from './SearchInput'
import { mobileSize, tabletSize } from 'theme'

const MobileSearchInput = ({ trackEvent, hideSearchBar }) => {
  const router = useRouter()
  const { searchKey } = router.query
  const [searchValue, setSearchValue] = useState(searchKey || '')
  const [autoFocus] = useState(!searchKey)

  const handleChange = useCallback((e) => {
    setSearchValue(e.target.value)
  }, [])

  const trackSearch = useCallback(
    (isSearchingSku) =>
      trackEvent(EVENT_ACTION.CLICK, {
        button: BUTTON_NAME.SEARCH,
        search_text: searchValue,
        screen: isSearchingSku
          ? COUPON_SCREEN_NAME.MYCOUPON
          : COUPON_SCREEN_NAME.SKUS,
      }),
    [searchValue, trackEvent]
  )

  const handleEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
        const isSearchingSku = router.pathname !== '/skus'
        trackSearch(isSearchingSku)
        if (isSearchingSku) {
          router.push(`/skus?searchKey=${searchValue}`)
        } else {
          const newUrl = URI(router.asPath)
            .search({ searchKey: searchValue })
            .toString()
          router.replace(newUrl)
        }
        e.target.blur()
      }
    },
    [router, searchValue, trackSearch]
  )

  const onCancelSearch = useCallback(() => {
    if (searchKey) {
      router.replace(`/skus`)
    }
    hideSearchBar()
  }, [hideSearchBar, router, searchKey])

  return (
    <SearchInputWrapper>
      <SearchInputInner action=".">
        <StyledInput
          value={searchValue}
          onKeyDown={handleEnter}
          onChange={handleChange}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
          autoFocus={autoFocus}
          placeholder="搜尋"
          type="search"
        />
        <CancelButton onClick={onCancelSearch}>取消</CancelButton>
      </SearchInputInner>
    </SearchInputWrapper>
  )
}

const SearchInputWrapper = styled.div`
  height: 64px;
  overflow: hidden;
  position: sticky;
  top: 44px;
  left: 0;
  width: 100%;
  z-index: 2;
  box-shadow: 0 1px 0 0 ${(p) => p.theme.color.grey80};
  @media ${mobileSize} {
    height: 48px;
  }
`

const SearchInputInner = styled.form`
  display: flex;
  align-items: center;
  position: relative;
  padding: 8px 12px;
  background-color: ${(p) => p.theme.color.white};
  ${boxShadow};
  @media ${tabletSize} {
    padding: 16px;
  }
  @media ${mobileSize} {
    padding: 8px 12px;
  }
`

const StyledInput = styled(InputBase)`
  padding: 0 9px;
  border-radius: 8px;
  background-color: ${(p) => p.theme.color.grey50};
  width: 100%;

  input {
    padding: 7px 0;
  }

  ${inputSearchCancelButtonStyle};
`

const CancelButton = styled.div`
  flex-shrink: 0;
  margin-left: 12px;
  line-height: 1.71;
  color: ${(p) => p.theme.color.blue200};

  ${(p) => p.hidden && hidden}
`

export default MobileSearchInput
